import { AdminUserInterface } from "../interfaces/Admin/AdminUserInterface";
import { CreateAdminUserInterface } from "../interfaces/Admin/CreateAdminuserinterface";
import BaseService from "./BaseServices";

export class AdminServices extends BaseService<AdminUserInterface, CreateAdminUserInterface>{
    constructor(){
        let url: string = '/admin-user/admin'
        super(url)
    }
}